import { render } from "./RuleStopGroup.vue?vue&type=template&id=07c0c6b8&scoped=true"
import script from "./RuleStopGroup.vue?vue&type=script&lang=js"
export * from "./RuleStopGroup.vue?vue&type=script&lang=js"

import "./RuleStopGroup.vue?vue&type=style&index=0&id=07c0c6b8&scoped=true&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c0c6b8"]])

export default __exports__